const animationIterationCount = {
  name: "animation-iteration-count",
  path: "/animation-iteration-count",
  title: "animation-iteration-count",
  description: "Utilities for controlling the number of times an animation repeats.",
  value: {
    "animation-iteration-count": {
      "iteration-<number>": "<number>"
    }
  },
  exampleData: [
    {
      example: {
        code: `<button class="animate-spin iteration-1 bg-color-blue-500 text-color-white font-bold py-2 px-4 rounded">
  Spin Once
</button>
<button class="animate-bounce iteration-3 bg-color-red-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Bounce 3 Times
</button>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">iteration-<var>&lt;number&gt;</var></code> to set how many times the animation repeats.
      </p>
      <div class="flex gap-4">
        <button class="flex gap-2 items-center bg-color-blue-500 text-color-white font-bold py-2 px-4 rounded">
            <div class="iteration-1 animate-spin size-5 rounded-full border-4 border-color-white/50 border-t-color-white"></div>
            Spin Once
        </button>
        <button class="animate-bounce iteration-3 bg-color-red-500 text-color-white font-bold py-2 px-4 rounded">
          Bounce 3 Times
        </button>
      </div>
      `
    }
  ]
};

export default animationIterationCount;
<div className="sr-only animate-spin iteration-1 animate-bounce iteration-3"></div>